import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import tr from "./languages/tr";
import en from "./languages/en";
import { DEFAULT_LANGUAGE } from "@Constants";
import { makeZodI18nMap } from "zod-i18n-map";
import { z } from "zod";

const currentLanguage = localStorage.getItem("language")
  ? JSON.parse(localStorage.getItem("language") || "") || DEFAULT_LANGUAGE.value
  : DEFAULT_LANGUAGE.value;

i18next.use(initReactI18next).init({
  lng: currentLanguage,
  resources: {
    tr: { translation: tr, ZOD: tr.ZOD, FORM: tr.FORM },
    en: { translation: en, ZOD: en.ZOD, FORM: en.FORM },
  },
  fallbackLng: DEFAULT_LANGUAGE.value,
  interpolation: {
    escapeValue: false,
  },
});

z.setErrorMap(
  makeZodI18nMap({
    ns: ["ZOD", "FORM"],
    handlePath: {
      keyPrefix: "FIELDS",
    },
  })
);
